export { AddTalentButton } from './AddTalentButton';
